export default [
  {
    name: 'unit-transfer',
    path: '/unit/transfer',
    component: () => import('@/views/units/transfer/UnitTransferWizard')
  }
]



// WEBPACK FOOTER //
// ./src/router/routeUnitsTransfer.js